/* src/app/shared/profile-pic/profile-pic.component.scss */
.profile-picture {
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 100%;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  margin: 0 auto;
  width: 7vw;
  height: 7vw;
  overflow: hidden;
}
.profile-picture img {
  width: 7vw;
  border-radius: 100%;
}
.transparent {
  opacity: 0.5;
  width: 10vw;
  height: 10vw;
  background: none;
}
.transparent > .profile-picture {
  width: 10vw;
  height: 10vw;
}
.transparent > .profile-picture > img {
  width: 10vw;
}
/*# sourceMappingURL=profile-pic.component.css.map */
